// extracted by mini-css-extract-plugin
export default {"MainLayout":"MainLayout__MainLayout___s2c1m","content":"MainLayout__content___pmid9"};